import React from 'react'
import ReactPlayer from 'react-player/youtube'

import * as style from "./responsivePlayer.module.scss";

const ResponsivePlayer  = ({ videoid }) => {
    return (
    <div className={style.ResponsivePlayer_playerWrapper}>
        <ReactPlayer
        className={style.ResponsivePlayer_reactPlayer}
        url={`https://www.youtube.com/watch?v=${videoid}`}
        width='100%'
        height='100%'
        />
    </div>
    )
}

export default ResponsivePlayer;

ResponsivePlayer.displayName = "ResponsivePlayer";